import * as React from 'react';
import { BaseInputComponent } from './BaseInputComponent';
export const Textarea = React.forwardRef((props, ref) => (React.createElement(BaseInputComponent, Object.assign({}, props, { ref: ref }),
    React.createElement("textarea", null, props.children))));
//# sourceMappingURL=Textarea.js.map